import { Action } from "./reducer"
import { Dispatch } from "react"

const startLoading = (dispatch: Dispatch<Action>) => {
    dispatch({ type: "START_LOADING" })
    return
}

const endLoading = (dispatch: Dispatch<Action>) => {
    dispatch({ type: "END_LOADING" })
    return
}

export { startLoading, endLoading }
